import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { TypeDePosteEntreprise } from '../models/options/typesDePosteEntreprise/typeDePosteEntreprise';

const baseResource = 'SecteursActivite'
const resource = 'TypesDePosteEntreprise'

export default class TypesDePosteEntrepriseResource {
  public async paginatedList(secteurActiviteId: string, pagenumber?: number, pagesize?: number, search?: string) : Promise<PaginatedList<TypeDePosteEntreprise>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString()); 
    params.append('SecteurActiviteId', secteurActiviteId); 

    const response = await api.get(`${baseResource}/${secteurActiviteId}/${resource}`, { params: params } )
    return response.data
  }
}
